<template>
  <div
    class="
      flex flex-col
      justify-evenly
      md:justify-center
      items-center
      bg-main bg-cover bg-center
      h-screen
    "
  >
    <h1 class="flex justify-center text-3xl font-bold pt-4 mb-4">
      Yennenga och Måljakten
    </h1>

    <div class="p-4 ml-2 mr-2 bg-white/80 md:w-3/4 rounded-lg max-w-md">
      <p class="text-sm md:text-xl xl:text-3xl text-center mb-4">
        Yennenga vill att sin by ska uppnå FN:s globala mål för hållbar
        utveckling.
      </p>
      <p class="text-sm md:text-xl xl:text-3xl text-center mb-4">
        Hennes pappa kungen är skeptisk, och tror inte att det är möjligt.
        Kungen är fast i gamla tider och vill jobba för en sak i taget. Pappa
        kungen tror inte att Yennenga klarar av att göra flera saker samtidigt
        då hon är flicka. Men Yennenga vet att hon kan, och hon vill ha din
        hjälp!
      </p>
      <p class="text-sm md:text-xl xl:text-3xl text-center">
        Hjälp Yennenga och hennes by att uppnå målen. Men akta dig för hennes
        arga pappa!
      </p>
    </div>
    <button
      class="
        bg-green-500
        hover:bg-green-600
        border-b-4 border-green-700
        rounded-lg
        w-36
        xl:w-56
        p-4
        md:m-10
        text-xl
        xl:text-3xl
        text-white
        font-semibold
      "
      @click="redirectToGamePage"
    >
      Spela
    </button>
  </div>
</template>

<script>
export default {
  name: "Main",
  data() {
    return {};
  },
  methods: {
    redirectToGamePage() {
      this.$router.push("/spel");
    },
  },
};
</script>

<style></style>
